import { __assign, __extends } from "tslib";
import React from 'react';
import UserLink from '../../../User/Link';
import BasicUserName from '../../../User/BasicUserName';
var MentionComponent = /** @class */ (function (_super) {
    __extends(MentionComponent, _super);
    function MentionComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MentionComponent.prototype.render = function () {
        if (!this.props || !this.props.componentData) {
            return null;
        }
        var _a = this.props, mention = _a.componentData.mention, children = _a.children;
        if (!mention || !mention.name) {
            return null;
        }
        // The renderer will pass in children we need to wrap our outer
        // with the styled child...
        var wrapStyles = {};
        if (children[1]) {
            wrapStyles = children[1].props.style;
        }
        if (mention.type) {
            var user = {
                type: mention.type || 'standard',
                username: mention.name,
                userId: mention.userId || 0,
                useridUuid: mention.userUuid || '',
                usericon: mention.avatar,
                isNewDeviant: false,
            };
            return (React.createElement("span", { style: __assign(__assign({}, this.props.style), wrapStyles), className: this.props.className },
                React.createElement(UserLink, { key: mention.name, user: user, withTooltip: false, className: "editor-mention-link" },
                    mention.name.length > 0 && mention.name[0] !== '@' && (React.createElement("span", { className: "editor-mention-prefix" }, "@")),
                    React.createElement(BasicUserName, { user: user }))));
        }
        // Fallback when we dont have enough info for user
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { style: __assign(__assign({}, this.props.style), wrapStyles), className: this.props.className, href: "https://www.deviantart.com/".concat(mention.name
                    .toLowerCase()
                    .replace(/^@/, '')), title: mention.name }, "".concat(mention.name))));
    };
    return MentionComponent;
}(React.Component));
export default MentionComponent;
//# sourceMappingURL=mentionComponent.js.map